import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, SplitButton, Tooltip } from "components";
import ManagerHeader from "features/manager/components/ManagerHeader";
import { PlusIcon, HelpIcon } from "./icons";
import { CREATE_CHOOSER, CREATE_ENTRIES } from "./createEntries";

/**
 * Dashboard top bar (PRD §4.2): brand · placeholder search · help · +New Game
 * split-button · account button. Composed from the shared <ManagerHeader />;
 * this file only supplies the dashboard-specific search/help/New-Game slots.
 * Search, Pre-crafted and Import CSV are §10 placeholders.
 */
const DashboardHeader = () => {
  const navigate = useNavigate();

  const newGameItems = CREATE_ENTRIES.map(({ label, Icon, route, soon }) => ({
    label: soon ? `${label}  ·  coming soon` : label,
    icon: <Icon size={15} />,
    onClick: route ? () => navigate(route) : undefined,
    disabled: !route,
  }));

  return (
    <ManagerHeader
      search
      actions={
        <Tooltip title="Help & shortcuts">
          <span>
            <IconButton variant="ghost" label="Help">
              <HelpIcon />
            </IconButton>
          </span>
        </Tooltip>
      }
      cta={
        <SplitButton
          variant="primary"
          startIcon={<PlusIcon />}
          onClick={() => navigate(CREATE_CHOOSER)}
          items={newGameItems}
          menuLabel="More ways to create"
        >
          New Game
        </SplitButton>
      }
    />
  );
};

export default DashboardHeader;
